import React, { Fragment } from 'react'

function MonthlyVolume({ data }) {
    const values = (data || []).map(d => d.count)
    const max = Math.max(1, ...values)
    const hasData = (data || []).some(d => d.count > 0)

    if(!hasData) {
        return (
            <Fragment>
                <p className='emptyState'>Aucun trajet enregistré sur les 6 derniers mois.</p>
            </Fragment>
        )
    }

  return (
    <Fragment>
        <div className='monthlyVolume'>
            {data.map((d, i) => {
                const isCurrent = i === data.length - 1
                const height = (d.count / max) * 100

                return (
                    <div className='barColumn' key={`${d.month}-${i}`}>
                        <span className='barValue'>{d.count}</span>
                        <div className='barTrack'>
                            <div className={`bar${isCurrent ? ' current' : ''}`} style={{ height: `${height}%` }}></div>
                        </div>
                        <span className='barLabel'>{d.month}</span>
                    </div>
                )
            })}
        </div>
    </Fragment>
  )
}

export default MonthlyVolume
